module.exports = __webpack_public_path__ + "linea-basic-elaboration-10.6c2c972e9ffa7ebb520e.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/linea-icons/fonts/linea-basic-elaboration-10.svg
// module id = ../../../../../src/scss/icons/linea-icons/fonts/linea-basic-elaboration-10.svg
// module chunks = styles